import { RootInitialState } from '@packages/shared/core/common/store/rootReducer';

export const getLocation = (state: RootInitialState) => {
  return state.location.location;
};

export const getUserCountry = (state: RootInitialState) => {
  return getLocation(state).country;
};

export const getLocationLoadingStatus = (state: RootInitialState) => {
  return state.location.loadingsStatus;
};
